import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setOption } from 'redux/reducers/orders';
import { getCurrentDesign } from 'redux/selectors/design';
import { getCurrentBookDesigns } from 'redux/selectors/books';

import { SidebarContent } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

@connect(
  state => ({
    designId: getCurrentDesign(state),
    designs: getCurrentBookDesigns(state),
  }),
  {
    setOption,
  }
)
export default class Design extends React.PureComponent {
  static contextTypes = {
    orderId: PropTypes.string,
  };

  select = e => {
    const { orderId } = this.context;
    const id = parseInt(e.currentTarget.dataset.id);
    this.props.setOption(orderId, 'design', id);
  };

  render() {
    const { designId, designs } = this.props;

    return (
      <SidebarContent innerClassName={styles.designs} title="Designs">
        <p className={styles.notes}>{kroostApp.strings.designInformations}</p>

        {designs
          .map(d => {
            const classes = cx(styles.book, {
              [styles.active]: designId === d.get('id'),
            });

            return (
              <div key={d.get('id')} className={classes} data-id={d.get('id')} onClick={this.select}>
                <div
                  className={styles.thumbnail}
                  style={{
                    backgroundImage: 'url(' + d.getIn(['thumbnail', 'url']) + ')',
                  }}
                />
                <div className={styles.label}>{d.get('name')}</div>
              </div>
            );
          })
          .toArray()}
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/design/index.js